import { CookieConsentService } from '@src/types'
import { api, ApiRes } from '@src/utils/api/client'

export interface CookieConsentServicesResponse {
    success: boolean
    cookie_consent_services: CookieConsentService[]
    cookie_consent_services_count: number
}

export interface CookieConsentServiceFilters {
    category?: string
    enabled?: boolean
}

export const getCookieConsentServices = (
    platformName: string,
    filters?: CookieConsentServiceFilters
): ApiRes<CookieConsentServicesResponse> => {
    return api.get(
        `v2/manage/platforms/${platformName}/cookie-consent-services`,
        { params: filters }
    )
}

export const createCookieConsentService = (
    platformName: string,
    cookieConsentService: CookieConsentService
): ApiRes<CookieConsentService> =>
    api.post(
        `v2/manage/platforms/${platformName}/cookie-consent-services`,
        cookieConsentService
    )

export const updateCookieConsentService = (
    platformName: string,
    cookieConsentService: CookieConsentService
): ApiRes<CookieConsentService> =>
    api.put(
        `v2/manage/platforms/${platformName}/cookie-consent-services/${cookieConsentService.id}`,
        cookieConsentService
    )

export const deleteCookieConsentService = (
    platformName: string,
    id: string
): ApiRes<string> =>
    api.delete(
        `v2/manage/platforms/${platformName}/cookie-consent-services/${id}`
    )

export const reorderCookieConsentServices = (
    platformName: string,
    items: { id: string; position: number }[]
): ApiRes<CookieConsentServicesResponse> =>
    api.put(
        `v2/manage/platforms/${platformName}/cookie-consent-services/reorder`,
        { items }
    )

export const seedDefaultCookieConsentServices = (
    platformName: string
): ApiRes<CookieConsentServicesResponse> =>
    api.post(
        `v2/manage/platforms/${platformName}/cookie-consent-services/seed-defaults`
    )
